import Client from '@/clients/base';
import BaseService from '@/services/base.service';

class AutoLoginService extends BaseService<any, any, any, any> {
    /**
     * 企业微信登陆
     * @param code 微信登录code
     */
    public async wxWorkAutoLogin(code: string): Promise<any> {
        const data = await this.client({
            url: this.path + '/system/auth/getWebChat',
            method: 'post',
            params: { code },
        });
        return data as unknown as string;
    }
}

const systemService = new AutoLoginService('', Client);
export default systemService;
